// export const API_URL = 'https://ftmo-api-dev.buso.asia';
// export const API_URL = 'https://ftmo-real-api.buso.asia';

//export const API_URL = 'https://lumir-api-dev.wealthfarming.org'
export const API_URL = 'https://reward-api.buso.asia'

//export const API_URL = 'http://192.168.1.92:8001'

export const API_USER_URL= 'https://reward-api-user.buso.asia'
//export const API_USER_URL= "http://192.168.1.92:8000"


// export const API_URL = 'https://0c8214ed97c8.ngrok-free.app'
export const API_URL_3 = 'https://78534d12e343.ngrok-free.app';
export const BOT_ZIGZAG_URL = 'http://localhost:3000';
export const INDEX_SENTIMENT_URL = 'https://chart.index.wealthfarming.org/';


export const DOMAIN_API = 'beq.busodevelopers.com'
export const SITE_ID = 343
export const API_URL_v2 = 'https://fund-forge-api.wealthfarming.org';

export const API_URL_IMAGE = 'http://beq-image.buso.asia';
export const LIMIT_EXPORT_EXCEL = 10000
export const API_GET_IMAGE = ''

export const CRM_HOST = 'https://crm.beqholdings.com';
export const SIGNING_CONTRACT_HASH_KEY = 'BEQ_SIGNING_CONTRACT_2026'; // Replace with a secure key in production
export const REACT_APP_PAYPAL_MODE = 'sandbox' // sandbox for dev, live for real
export const BOT_TELEGRAM = 'sandbox' // sandbox for dev, live for real

export const Web3_ENV: "testnet" | "mainnet" = 'testnet' // testnet for dev, mainnet for real
